import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const useTimeFilterContextValue = (options = [])=>{
    const initialActiveState = React.useRef(options.reduce((acc, option)=>{
        acc[option.name] = false;
        return acc;
    }, {}));
    const [active, setActive] = React.useState(initialActiveState.current);
    const addActiveFilter = React.useCallback((name)=>setActive((curr)=>swcHelpers.objectSpread({}, curr, {
                [name]: true
            })
        )
    , []);
    const removeActiveFilter = React.useCallback((name)=>setActive((curr)=>swcHelpers.objectSpread({}, curr, {
                [name]: false
            })
        )
    , []);
    const clearActiveFilters = React.useCallback(()=>setActive(initialActiveState.current)
    , []);
    return React.useMemo(()=>[
            {
                addActiveFilter,
                removeActiveFilter,
                clearActiveFilters
            },
            {
                options,
                active
            }, 
        ]
    , [
        addActiveFilter,
        removeActiveFilter,
        clearActiveFilters,
        options,
        active
    ]);
};
const missingContextProviderWarning = ()=>console.warn('Missing TimeFilterContextProvider')
;
const fallbackValue = [
    {
        addActiveFilter: missingContextProviderWarning,
        removeActiveFilter: missingContextProviderWarning,
        clearActiveFilters: missingContextProviderWarning
    },
    {
        options: [],
        active: {}
    }, 
];
const timeFilterContext = /*#__PURE__*/ React.createContext(fallbackValue);
const useTimeFilterContext = ()=>React.useContext(timeFilterContext)
;
const TimeFilterContextProvider = ({ configuration , children ,  })=>{
    const { Provider  } = timeFilterContext;
    const value = useTimeFilterContextValue(configuration);
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, children);
};

export { TimeFilterContextProvider, timeFilterContext, useTimeFilterContext };
//# sourceMappingURL=TimeFilterContext.js.map
